/**
 * Mixin to add functionality to a user confirm modal
 * Supports callback that gets called on confirm
 */

export default {
  data() {
    return {
      // The callback that resumes the user's intended functionality
      // when clikcing ok
      $_confirmLeaveModal_callback: null,
      // Toggles whether the modal is shown or not
      confirmLeaveModal_isVisible: false,
    };
  },
  methods: {
    // Opens the modal and sets the callback
    confirmLeaveModal_open(callback) {
      this.$_confirmLeaveModal_callback = callback;
      this.confirmLeaveModal_isVisible = true;
    },
    // Closes the modal
    confirmLeaveModal_close() {
      this.confirmLeaveModal_isVisible = false;
    },
    // Handles clicking cancel
    confirmLeaveModal_cancel() {
      this.confirmLeaveModal_close();
    },
    // Handles clicking confirm
    confirmLeaveModal_confirm() {
      this.confirmLeaveModal_close();
      this.$_confirmLeaveModal_callback();
    },
  },
};
